import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">🔥 بصمة آثر وآركان أكاديمي… هنا حلمك بيبدأ! 🔥</h1>
          <p className="hero-subtitle">احلم كبير… وسيب الباقي علينا ❤</p>
          <p className="hero-description">
            في بصمة آثر وآركان أكاديمي إحنا مش بس مؤسسة لدعم المواهب…<br />
            إحنا عيلتك اللي هتمسك إيدك وتطلع بيك للنجاح خطوة بخطوة 🚀
          </p>
          <div className="hero-buttons">
            <button onClick={() => scrollToSection('books')} className="btn btn-primary">
              تصفح الكتب
            </button>
            <button onClick={() => scrollToSection('contact')} className="btn btn-secondary">
              انضم إلينا
            </button>
          </div>
        </div>
        <div className="hero-image">
          <i className="fas fa-book-open"></i>
        </div>
      </div>
    </section>
  );
};

export default Hero;
